// stores/app.js
import { defineStore } from 'pinia'
import { eventBus } from '../utils/eventBus'

export const useAppStore = defineStore('app', {
  state: () => ({
    online: navigator.onLine,
    queued_items: 0,
    tracked_changed: 0,

    currentDateTs: Date.now()
  }),
  actions: {
    setOnline(status) {
      this.online = status
    },

    triggerTrackedChanged() {
      this.tracked_changed ++;
    },

    // navigation handlers
    changeDate(days) {
        // add one day
        const newDateTs = this.currentDateTs + days * 24 * 60 * 60 * 1000
        this.currentDateTs = newDateTs
        eventBus.emit('app:dateChanged', {
          newDate: new Date(newDateTs)
        })
    }

  }
})
